import { GET_INTEGRATIONS_SUCCESS } from '../../../actions/api/integrations';
import { INTLIST_INITIALIZE } from '../../../actions/page/admin/IntegrationList';

export default function IntegrationList(state = {}, action) {
  switch (action.type) {
    case INTLIST_INITIALIZE:
      const defaults = {
        loadingInts: true
      };
      return {
        ...state,
        ...defaults
      };
    case GET_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        loadingInts: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/admin/IntegrationList.js